import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { ModalController, NavController, NavParams } from '@ionic/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@Component({
    selector: 'app-popover',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PopoverComponent implements OnInit {

    hostLink: string;
    @Input() userEmail: string;
    constructor(
        private modalController: ModalController,
        private navCtrl: NavController,
        private navParams: NavParams
    ) {

    }

    ngOnInit() {
        const origin = document.location.origin;
        if(this.userEmail){
        this.hostLink = `https://meetings.hubspot.com/amo-advisors/dashboard?email=${this.userEmail}`;
        }
       
    }
    
    dismiss() {
        this.modalController.dismiss();
    }
}
